import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, Upload, Eye } from 'lucide-react';

interface SequenceUploadSuccessModalProps {
  isOpen: boolean;
  sequenceTitle: string;
  sequenceId: string;
  onUploadAnother: () => void;
  onViewSequence: () => void;
}

const SequenceUploadSuccessModal: React.FC<SequenceUploadSuccessModalProps> = ({
  isOpen,
  sequenceTitle,
  sequenceId,
  onUploadAnother,
  onViewSequence,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <DialogTitle className="text-xl font-semibold text-green-900">
            Sequence Submitted Successfully!
          </DialogTitle>
          <DialogDescription className="text-gray-600 mt-2">
            Your sequence "<span className="font-medium text-gray-900">{sequenceTitle}</span>" has been uploaded 
            and is now live on the marketplace.
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-3 mt-6">
          <Button 
            onClick={onViewSequence}
            size="lg"
            className="w-full flex items-center justify-center gap-2"
          >
            <Eye className="w-4 h-4" />
            View Sequence Live
          </Button>
          
          <Button 
            onClick={onUploadAnother}
            variant="outline"
            size="lg"
            className="w-full flex items-center justify-center gap-2"
          >
            <Upload className="w-4 h-4" />
            Upload Another Sequence
          </Button>
        </div>
        
        <p className="text-xs text-center text-muted-foreground mt-4">
          Your sequence is immediately available for download and purchase.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default SequenceUploadSuccessModal;